export function downloadBlob(blob: Blob, filename: string): void {
  const link = document.createElement('a')
  if (link.download !== undefined) {
    // feature detection, Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', filename)
    // link.style = 'visibility:hidden';
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
